// extracted by mini-css-extract-plugin
module.exports = {"root":"sn-spinner-module--root--LFxUc","fadeinout":"sn-spinner-module--fadeinout--3xx_U"};